export const SortFilter = [
{
	value: "Featured",
	label: "Featured"
},{
	value: "AvgCustomerReviews",
	label: "Avg Customer Reviews"
},{
	value: "NewestArrivals",
	label: "Newest Arrivals"
},{
	value: "Price:HighToLow",
	label: "Price: High To Low"
},{
	value: "Price:LowToHigh",
	label: "Price: Low To High"
},{
	value: "Relevance",
	label: "Relevance"
}]
